import { render, staticRenderFns } from "./ExternalAccessForm.vue?vue&type=template&id=c85361ac&scoped=true"
import script from "./ExternalAccessForm?vue&type=script&lang=ts&external"
export * from "./ExternalAccessForm?vue&type=script&lang=ts&external"
import style0 from "./ExternalAccessForm.scss?vue&type=style&index=0&id=c85361ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85361ac",
  null
  
)

export default component.exports